import { Check } from 'lucide-react'

import { StatusPill } from '@/components/px/StatusPill'

/**
 * LOCKED — the DECISION object, the round's best component (cross-panel
 * finding #7): booked-to / approved-by-at (AUBERGINE chip — a decision is
 * decided furniture) / what-happened-automatically chips / the logged line
 * with a REACHABLE `view override reason →` (ledger borrow; prose-only audit
 * affordances are avoid-list #5). Reused verbatim on every surface where a
 * human merges.
 */
export function DecisionCard({
  heading = 'Decision',
  summary,
  approvedBy,
  approvedAt,
  consequences,
  loggedLine,
  overrideHref,
  primaryAction,
}: {
  heading?: string
  summary: React.ReactNode
  approvedBy: string
  approvedAt: string
  consequences: readonly string[]
  loggedLine: string
  overrideHref: string
  primaryAction?: React.ReactNode
}) {
  return (
    <div className="rounded-lg border border-border bg-card px-4 py-3">
      <div className="flex items-center justify-between gap-2">
        <div className="text-[0.6875rem] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          {heading}
        </div>
        {primaryAction}
      </div>
      <div className="mt-1.5 text-sm text-foreground">{summary}</div>
      <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
        <StatusPill tone="decided">
          <Check className="h-3 w-3" aria-hidden />
          Approved by {approvedBy} · {approvedAt}
        </StatusPill>
        {consequences.map((c) => (
          <StatusPill key={c} tone="neutral">
            {c}
          </StatusPill>
        ))}
      </div>
      <div className="mt-2.5 flex items-center justify-between gap-2 border-t border-border pt-2 text-xs text-muted-foreground">
        <span>{loggedLine}</span>
        <a href={overrideHref} className="shrink-0 font-medium text-accent-foreground hover:underline">
          view override reason →
        </a>
      </div>
    </div>
  )
}
